import React from 'react';
const Checkbox = ({ label, isCheckboxChecked, setIsCheckboxChecked }) => {
    return (React.createElement("div", { className: "hg-modal__checkbox" },
        React.createElement("input", { id: "hg-modal__confirmation", className: "hg-modal__confirmation", type: "checkbox", checked: isCheckboxChecked, onChange: (e) => setIsCheckboxChecked(e.target.checked) }),
        React.createElement("label", { htmlFor: "hg-modal__confirmation" }, label)));
};
export default Checkbox;
